"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Download_1 = __importDefault(require("./Download"));
class Index {
    constructor(parent, recordingId = null) {
        this.parent = parent;
        this.rc = parent.rc;
        this.recordingId = recordingId;
    }
    path(withParameter = true) {
        if (withParameter && this.recordingId !== null) {
            return `${this.parent.path()}/recordings/${this.recordingId}`;
        }
        return `${this.parent.path()}/recordings`;
    }
    /**
     * Returns the list of webinar recordings for a given webinar host user
   *
     * HTTP Method: get
     * Endpoint: /webinar/history/v1/recordings
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */
    async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the webinar recording by ID (Webinar host's interface).
   * This API also returns sharing link if sharing is enabled.
   *
     * HTTP Method: get
     * Endpoint: /webinar/history/v1/recordings/{recordingId}
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */
    async get(restRequestConfig) {
        if (this.recordingId === null) {
            throw new Error('recordingId must be specified.');
        }
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    download() {
        return new Download_1.default(this);
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map